import { SHELL } from "../constants/environment.js";
import "./states.css";

/**
 * Shown when /runtime-config.json fails to load or fails validation.
 * Must never call any backend API and must never leak technical detail
 * (URLs, stack traces, secrets) to the operator  -  only a safe reference
 * code they can quote to support.
 */
export default function ConfigErrorState({ error }) {
  const referenceCode = error?.reason ?? "unknown";

  return (
    <div className="wx-state-screen" role="alert">
      <div className="wx-state-card wx-state-card--danger">
        <h1 className="wx-state-title">ระบบไม่สามารถเริ่มทำงานได้</h1>
        <p className="wx-state-body">
          ไม่สามารถโหลดการตั้งค่าระบบ Workmate X ได้ในขณะนี้ กรุณาลองรีเฟรชหน้าจออีกครั้ง
          หากยังพบปัญหา กรุณาติดต่อฝ่ายปฏิบัติการ
        </p>
        <p className="wx-state-contact">
          ติดต่อฝ่ายปฏิบัติการ: <a href={`mailto:${SHELL.DEFAULT_SUPPORT_CONTACT}`}>{SHELL.DEFAULT_SUPPORT_CONTACT}</a>
        </p>
        <p className="wx-state-reference">รหัสอ้างอิงสำหรับฝ่ายสนับสนุน: {referenceCode}</p>
      </div>
    </div>
  );
}
